import { FC } from 'react'

import { Input } from './styles'
import { SearchInputProps } from './types'

export const SearchInput: FC<SearchInputProps> = ({
  placeholder = 'Search',
  value = '',
  suggestion = '',
  shouldComplete,
}) => (
  <Input>
    {!value && placeholder && <span>{placeholder}</span>}
    {value && <strong>{value}</strong>}
    {value && suggestion && shouldComplete && (
      <span>{suggestion.substring(value.length)}</span>
    )}
  </Input>
)
